import React, {useEffect, useState} from "react";
import CameraComponent from "../../components/common/camera/CameraComponent";
import {useParams} from "react-router-dom";
import {RouteParam} from "../../types/types";
import {VerifyService} from "../../service/VerifyService";
import {MaskType} from "../../components/common/camera/MaskType";
import ProcessingComponent from "../../components/common/processing/ProcessingComponent";
import {useStepCheck} from "../../hooks/stepcheck/useStepCheck";
import {FacingModeType} from "../../components/common/camera/FacingModeType";
import {VerifyExtractionViewModel} from "../../viewmodel/extraction/VerifyExtractionViewModel";
import {ResultStatusType} from "../../domain/verification/ResultStatusType";
import {useSubmit} from "../../hooks/submit/useSubmit";
import {TimeoutDocumentFrontStepViewModel} from "../../viewmodel/timeout/TimeoutDocumentFrontStepViewModel";

const CaptureDocumentFrontPage: React.FC = () => {

    const { verificationId } = useParams<RouteParam>();
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const { evaluateUrl } = useStepCheck(verificationId)
    const { submitImage } = useSubmit(verificationId)
    const { verifyExtractionResult } = VerifyExtractionViewModel(verificationId)
    const { timeout } = TimeoutDocumentFrontStepViewModel()

    useEffect(() => {
        evaluateUrl()
    }, [evaluateUrl])

    const onPhotoTaken = () => {
        setLoading(true)
    }

    const onSubmit = async (image: Blob) => {
        submitImage(image, submitAction, () => setLoading(false))
    }

    const submitAction = async (selfie: Blob) => {
        if (!verificationId) return

        setLoading(true)
        await VerifyService.getInstance().sendSelfie(selfie, verificationId)

        const pollResult = async (attempt: number) => {
            const result = await verifyExtractionResult()

            const done = result.toLowerCase() !== ResultStatusType.PENDING
            const maxAttemptsReached = attempt > 10

            if (done || maxAttemptsReached) {
                if (done) {
                    setSuccess(true)
                    setTimeout(async () => {
                        try {
                            await evaluateUrl()
                        } finally {
                            setSuccess(false)
                            setLoading(false)
                        }
                    }, 1000)
                } else {
                    await timeout(verificationId)
                    try {
                        await evaluateUrl()
                    } finally {
                        setSuccess(false)
                        setLoading(false)
                    }
                }

                return
            }

            setTimeout(() => {
                pollResult(attempt + 1)
            }, 1000)
        }

        pollResult(1)
    }

    return loading ? (
        <ProcessingComponent loadingAnimation="processingSelfie" successAnimation="processComplete" success={success}/>
    ) : (
        <CameraComponent
            onSubmit={(blob: Blob) => onSubmit(blob)}
            onPhotoTaken={() => onPhotoTaken()}
            maskType={MaskType.SELFIE}
            facingMode={FacingModeType.USER}
            tooltip="Position your face inside the oval"
            identifierText="Selfie"
            withRetake
        />

    )

}

export default CaptureDocumentFrontPage